<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ title }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">{{ title }}</li>
        </ol>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">User ID</label>
                    <input v-model="id_user" class="form-control" placeholder="User ID" style="width:100%" type="text"
                           name="" maxlength="30">
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">URL</label>
                    <input v-model="url" class="form-control" placeholder="URL" style="width:100%" type="text"
                           name="" maxlength="30">
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">Request method</label>
                    <select type="text" v-model="request_method" class="form-control">
                      <option value="all">All</option>
                      <option value="GET">GET</option>
                      <option value="POST">POST</option>
                      <option value="PATCH">PATCH</option>
                      <option value="DELETE">DELETE</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">Response status code</label>
                    <select type="text" v-model="response_status_code" class="form-control">
                      <option value="all">All</option>
                      <option value="200">200</option>
                      <option value="201">201</option>
                      <option value="400">400</option>
                      <option value="500">500</option>
                      <option value="503">503</option>
                      <option value="504">504</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">APP name</label>
                    <select type="text" v-model="app_name" class="form-control">
                      <option value="all">All</option>
                      <option value="driver_app">verida_driver_app</option>
                      <option value="driver_dashboard">verida_driver_dashboard</option>
                      <option value="cs_tool">verida_cs_tool</option>
                      <option value="booking_portal">verida_booking_portal</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">APP platform</label>
                    <select type="text" v-model="app_platform" class="form-control">
                      <option value="all">All</option>
                      <option value="iOS">iOS</option>
                      <option value="Android">Android</option>
                      <option value="Web">Web</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">APP version</label>
                    <input v-model="app_version" class="form-control" placeholder="APP version" style="width:100%" type="text"
                           name="" maxlength="30">
                  </div>
                </div>

                <div class="col-md-4 col-lg-4 p-0">
                  <div class="m-2">
                    <label class="search-label">Exclude URLs (separated by comma)</label>
                    <textarea type="text" v-model="exclude" class="form-control">

                    </textarea>
                  </div>
                </div>

                <div class="col-12 p-0 submit-button">
                  <button v-on:click="buttonSearch(currentPage)" class="btn btn-info waves-effect waves-light m-t-10">Search</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="result">

              <div class="table-responsive">
                <table class="table table-hover table-sm">
                  <thead>
                  <tr>
                    <th class="result-label" v-for="column in data.resultColumns" v-on:click="sortResults($event)">
                      <div class="" >
                        {{column}}
                        <div class="arrow-down" v-bind:id="column" style="visibility: hidden; margin-left: 5px;"></div>
                      </div>
                    </th>
                  </tr>
                  </thead>
                  <tbody class="col-12">
                  <tr v-for="log in data.rides">
                    <td class="text-primary result-item">
                      <router-link :to="'/request-logs/' + log.id + '/'">
                        {{ log.id }}
                      </router-link>
                    </td>
                    <td class="result-item" :style="log.response_status_code >= 400 ? 'color:red' : ''">
                      {{ log.response_status_code }}
                    </td>
                    <td class="text-primary result-item">
                      <div v-if="log.id_user">
                      <router-link :to="'/users/' + log.id_user.id_user + '/'">
                        {{ log.id_user.name_first + ' ' + log.id_user.name_last }}
                      </router-link>
                      </div>
                      <div v-else>
                        Anonymous User
                      </div>
                    </td>
                    <td class="result-item">
                      {{ log.request_method }}
                    </td>
                    <td class="result-item">
                      {{ log.url }}
                    </td>
                    <td class="result-item">
                      {{ log.app_name ? log.app_name : 'N/A' }}
                    </td>
                    <td class="result-item">
                      {{ log.app_platform ? log.app_platform : 'N/A' }}
                    </td>
                    <td class="result-item">
                      {{ log.app_version ? log.app_version : 'N/A' }}
                    </td>
                    <td class="result-item" :style="log.time_spent >= 1000 ? 'color:#ff9966' : ''">
                      {{ (log.time_spent/1000).toFixed(2) + 's' }}
                    </td>
                    <td class="result-item">
                      {{ moment(log.created_at).format("MMMM Do, YYYY \\at h:mm a")  + " (" + moment.tz.guess() + ")" }}
                    </td>
                    <!--<td class="result-item">-->
                    <!--{{ driver.id_referrer ? driver.id_referrer.name_first : 'N/A' }}-->
                    <!--</td>-->
                  </tr>
                  </tbody>
                </table>
              </div>

              <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                <div style="margin: 1rem 1rem; float: left;">
                  <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                  <span v-else>Showing 0 entries</span>
                </div>

                <div style="margin: 0 1rem; float: right;">
                  <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                  </b-pagination>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Search Request Logs',
    },
    name: 'SearchRequestLogs',
    data () {
      return {
        title: 'Search Request Logs',
        data: {
          rides: [],
          filteredRides: [],
          sortedRides: [],
          resultColumns: ["ID", "Status code", "User", "Method", "URL", "APP name", "APP platform", "APP version", "Time spent", "Created at",],
          filters: {},
        },
        id_driver: null,
        driver_email: null,
        driver_name_first: null,
        driver_name_last: null,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        with_deactivated: false,
        id_user: null,
        url: null,
        response_status_code: "all",
        request_method: "all",
        app_platform: "all",
        app_version: null,
        app_name: "all",
        exclude: '/cs/request-logs,/locations,/bulk-location'
      }
    },
    components: {
      Loading
    },
    methods: {
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL_CS + 'request-logs/?'
            + 'page=' + (page ? page : this.currentPage)
            + '&id_user=' + (!this.id_user ? '' : this.id_user)
            + '&url=' + (!this.url ? '' : this.url)
            + '&request_method=' + (this.request_method == 'all' ? '' : this.request_method)
            + '&response_status_code=' + (this.response_status_code == 'all' ? '' : this.response_status_code)
            + '&app_name=' + (this.app_name == 'all' ? '' : this.app_name)
            + '&app_platform=' + (this.app_platform == 'all' ? '' : this.app_platform)
            + '&app_version=' + (!this.app_version ? '' : this.app_version)
            + '&exclude=' + (this.exclude ? this.exclude : '')
          )
          .then(response => {
            this.data.rides = response.data.results
            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      }
    },
    mounted () {
      this.search()
    },
    created () {
      // document.title = "Wingz Support | Driver Search";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchRequestLogs.vue